import { render, staticRenderFns } from "./LoginTemplate.vue?vue&type=template&id=f5fdb960&scoped=true&"
import script from "./LoginTemplate.vue?vue&type=script&lang=js&"
export * from "./LoginTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LoginTemplate.vue?vue&type=style&index=0&id=f5fdb960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fdb960",
  null
  
)

export default component.exports